export default __webpack_public_path__ + "static/media/dogs.c3607297.png";